import logger from "redux-logger";
import { createStore, applyMiddleware } from "redux";
import * as INITIAL_STATE from "./Reducer.InitialState";

import { LevelReducer } from "./LevelReducer";
import { NotebookReducer } from "./NotebookReducer";
import { CSCQReducer } from "./CSCQReducer";
import { MSCQReducer } from "./MSCQReducer";
import { GDNDQReducer } from "./GDNDQReducer";
import { DNDQReducer } from "./DNDQReducer";
import { DDQReducer } from "./DDQReducer";
import { DesignReducer } from "./DesignReducer";
import { ViewThreeReducer } from "./ViewThreeReducer";
import { ViewFourReducer } from "./ViewFourReducer";
import { PageTourReducer } from "./PageTourReducer";

import { DesignReducer as DesignReducerNew } from "./DesignReducerNew";
import { MenuListReducer } from "./MenuListReducer";
import { NotebookDrawerReducer } from "./NotebookDrawerReducer";
import { NotebookDataReducer } from "./NotebookDataReducer";
import { ShowLevelSelectorReducer } from "./ShowLevelSelectorReducer";
import { TourReducer } from "./TourReducer";
import { CSCQReducerNew } from "./CSCQReducerNew";
import { MSCQReducerNew } from "./MSCQReducerNew";
import { ColorPredictionReducer } from "./ColorPredictionReducer";

const rootReducer = (state = INITIAL_STATE.default, action) => {
  state = LevelReducer(state, action);
  state = NotebookReducer(state, action);

  state = CSCQReducer(state, action);
  state = MSCQReducer(state, action);
  state = GDNDQReducer(state, action);
  state = DNDQReducer(state, action);
  state = DDQReducer(state, action);

  state = DesignReducer(state, action);
  state = ViewThreeReducer(state, action);
  state = ViewFourReducer(state, action);
  state = PageTourReducer(state, action);
  return state;
};

export const Store = createStore(rootReducer, applyMiddleware(logger));

export const Reducers = {
  LevelReducer,
  NotebookReducer,
  CSCQReducer,
  MSCQReducer,
  GDNDQReducer,
  DNDQReducer,
  DDQReducer,
  ViewThreeReducer,
  ViewFourReducer,
  PageTourReducer,
  DesignReducerNew,
  MenuListReducer,
  NotebookDrawerReducer,
  NotebookDataReducer,
  ShowLevelSelectorReducer,
  TourReducer,
  CSCQReducerNew,
  MSCQReducerNew,
  ColorPredictionReducer,
};
